import type { FC, PropsWithChildren, ReactNode } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

interface IDefaultPageLayoutProps {
  header?: ReactNode;
}

export const DefaultPageLayout: FC<PropsWithChildren<IDefaultPageLayoutProps>> = (props) => {
  const { children, header } = props;

  return (
    <Layout>
      {header ? <div style={{ background: '#fff', paddingBlock: '6px' }}>{header}</div> : null}
      <Content style={{ margin: '12px' }}>{children}</Content>
    </Layout>
  );
};
